import { DisplayProperties } from '../../../models';

export interface Stipulation extends DisplayProperties {
  title: string;
  content: string;
}
